import { NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { pageTransitions } from '../../../animations/page-transitions';
import { DatacenterFreeTextFilter, DynamicDatacenterFilter } from '../../../models/datacenter-filters';

@Component({
	selector: 'copo-free-text-filter',
	templateUrl: './view-free-text-filter.component.html',
	styleUrl: './view-free-text-filter.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		NgFor,
		MatIconModule,
		MatRippleModule,
		MatFormFieldModule,
		MatInputModule,
		FormsModule,
		MatButtonModule,
	]
})
export class ViewFreeTextFilterComponent implements DynamicDatacenterFilter<DatacenterFreeTextFilter> {
	@Input() filter?: DatacenterFreeTextFilter;
	@Output() readonly removeFilter = new EventEmitter<void>();
	@Input() isDefaultFilter?: boolean;
	removeValue(index: number) {
		if (!this.filter) {
			return;
		}
		this.filter.getValues().splice(index, 1);
		if (!this.filter.valueSize()) {
			this.removeFilter.emit();
		}
	}

	trackByFunc(index: number) {
		return index;
	}

	getPreparedFilterValues() {
		if (this.filter) {
			return { id: this.filter.filterId, values: this.filter.getValues().filter(filterValue => !filterValue) };
		}
		return undefined;
	}
}
